// extracted by mini-css-extract-plugin
export var footer = "ModalDepartureDate-module--footer--90ca4";
export var hideModal = "ModalDepartureDate-module--hide-modal--8cf5f";